import {Exclude, Expose, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {GeoCoord} from "./geo-coord";
import {Entity} from "./entity";

/** Validator for driver location types. */
export const DriverLocationValidator = t.intersection([
  t.type({
    id: t.string,
    shiftId: t.string,
    createDttm: t.number,
    latCoord: t.number,
    longCoord: t.number,
  }),
  t.partial({
    speed: t.number,
    speedAccuracy: t.number,
    bearing: t.number,
    bearingAccuracy: t.number,
    personId: t.string,
    trailerId: t.string,
    driverName: t.string,
  }),
]);

/** Validator for driver location array types. */
export const DriverLocationArrayValidator = t.array(DriverLocationValidator);

export type DriverLocation = t.TypeOf<typeof DriverLocationValidator>;
export type DriverLocationArray = t.TypeOf<typeof DriverLocationArrayValidator>;

/**
 * A driver location.
 */
@Exclude()
export class DriverLocationEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  shiftId!: string;

  @Expose()
  personId?: string;

  @Expose()
  trailerId?: string;

  @Expose()
  driverName?: string;

  @Expose()
  longCoord!: number;

  @Expose()
  latCoord!: number;

  @Expose()
  speed?: number

  @Expose()
  speedAccruacy?: number

  @Expose()
  bearing?: number

  @Expose()
  bearingAccuracy?: number

  @Expose()
  createDttm!: number;

  readonly entityType = 'DRIVERLOCATION';

  get displayName(): Readonly<string> {
    return `(${this.latCoord}, ${this.longCoord})`;
  }

  /**
   * Constructor for DriverLocationEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(driverLocation: DriverLocation): DriverLocationEntity {
    return plainToInstance(
      DriverLocationEntity,
      driverLocation,
      {
        excludeExtraneousValues: true,
      }
    );
  }

  get coordinates(): GeoCoord {
    /* istanbul ignore next */
    return {
      latCoord: this.latCoord,
      longCoord: this.longCoord,
      speed: this.speed,
      bearing: this.bearing,
      dttm: this.createDttm,
    };
  }
}
